module.exports = __webpack_public_path__ + "img/kid-prem.0ac55c30.jpg";